var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.58341 11.9167L11.9167 2.16675C12.7787 2.16675 13.6054 2.50916 14.2148 3.11865C14.8243 3.72814 15.1667 4.55479 15.1667 5.41675V9.75008H21.2984C21.6125 9.74653 21.9236 9.81129 22.2101 9.9399C22.4967 10.0685 22.7518 10.2579 22.9579 10.4949C23.164 10.7319 23.3161 11.0109 23.4037 11.3125C23.4913 11.6142 23.5122 11.9312 23.4651 12.2417L21.9701 21.9917C21.8917 22.5084 21.6293 22.9793 21.2311 23.3178C20.833 23.6562 20.3259 23.8393 19.8034 23.8334H7.58341M7.58341 11.9167V23.8334M7.58341 11.9167H4.33341C3.75878 11.9167 3.20768 12.145 2.80135 12.5514C2.39502 12.9577 2.16675 13.5088 2.16675 14.0834V21.6667C2.16675 22.2414 2.39502 22.7925 2.80135 23.1988C3.20768 23.6051 3.75878 23.8334 4.33341 23.8334H7.58341",
    stroke: "currentColor",
    strokeWidth: 2.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUp);
export default __webpack_public_path__ + "static/media/ThumbsUp.546ff09fde606bfb82c826ddb66ba8a2.svg";
export { ForwardRef as ReactComponent };